import { jsxs as o, jsx as C } from "react/jsx-runtime";
function e(t) {
  return /* @__PURE__ */ o("svg", { fill: "none", height: "100%", viewBox: "0 0 26 29", width: "31", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
    /* @__PURE__ */ o("g", { clipPath: "url(#clip0_1340_77668)", children: [
      /* @__PURE__ */ C(
        "path",
        {
          d: "M1.38835 17.5241C1.38835 14.9145 2.65048 13.932 2.90291 11.4452C2.55582 13.625 1.07281 15.375 1.07281 17.5241C1.07281 18.353 1.19903 19.0898 1.38835 19.7653C2.3034 22.774 5.0801 24.4319 7.73058 25.1073C3.66019 24.0941 1.38835 20.717 1.38835 17.5241ZM24.8956 17.5241C24.8956 16.1732 24.517 15.0987 24.1068 14.1162C23.6019 12.9496 23.0655 11.875 23.0655 10.5549C23.0655 13.7171 24.6116 14.6381 24.6116 17.5241C24.6116 20.717 22.3714 24.0941 18.2694 25.1073C21.9612 24.1862 24.8956 21.5459 24.8956 17.5241Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M23.5388 4.87514C22.6869 4.62953 22.0874 4.01551 21.7087 3.03307L20.8883 0.761169L20.4781 2.20413C21.2985 5.73478 24.2645 5.98039 24.2645 5.98039L25.4636 5.42777L23.5388 4.87514ZM9.466 17.739L7.91988 15.4057L6.18445 16.6644C6.18445 16.6644 6.78396 16.6951 6.78396 17.3092V21.6995L8.01454 20.8091V17.7083L9.40289 19.796L10.6966 18.8442V13.3794L9.466 14.2697V17.739ZM14.4514 12.6426L13.0631 13.6557V11.6294L11.2014 12.9803C11.2014 12.9803 11.801 13.011 11.801 13.625V18.0153L13.0631 17.0943V15.0987L14.4514 14.0855V16.1118L15.6505 15.2522V9.75665L14.4514 10.647V12.6426ZM17.9223 12.1514V8.06808L16.0607 9.41894C16.0607 9.41894 16.6602 9.44964 16.6602 10.0637V14.454L20.131 11.9057C20.0679 11.0461 20.131 10.5242 20.131 10.5242L17.9223 12.1514Z",
          fill: "#E4E5E6"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M2.08255 10.5549C2.08255 13.6557 0.504883 14.2698 0.504883 17.5241C0.504883 18.5065 0.66265 19.4583 0.978184 20.2872C1.07284 20.103 1.23061 19.8881 1.38838 19.7653C1.1675 19.0899 1.07284 18.353 1.07284 17.5241C1.07284 15.4057 2.55585 13.625 2.90294 11.4452C2.93449 11.1689 2.9345 10.8619 2.9345 10.5549C2.96605 8.06811 1.73547 5.98042 1.73547 5.98042L0.536436 5.4278L1.35682 7.23917C1.76702 8.16021 2.08255 9.29616 2.08255 10.5549Z",
          fill: "url(#paint0_linear_1340_77668)"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M23.0656 10.5549C23.0656 11.8751 23.602 12.9189 24.1068 14.1163L24.7694 14.0856C24.3592 13.1031 23.949 12.1514 23.949 10.5549C23.949 9.29616 24.2646 8.16021 24.6748 7.23917L25.4952 5.4278L24.2646 5.98042C24.2646 5.98042 23.0656 8.06811 23.0656 10.5549Z",
          fill: "url(#paint1_linear_1340_77668)"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M12.0534 26.059C11.0752 25.7213 9.71844 25.5985 7.76213 25.1073C5.08009 24.4626 2.33495 22.774 1.4199 19.7653C1.26213 19.9188 1.10436 20.103 1.0097 20.2872C2.05097 23.1731 4.70145 25.1994 7.54126 25.9362C9.37136 26.3968 10.2233 26.4275 11.5801 26.7959C11.7694 26.9801 13 28.3002 13 28.3002V27.0415C13 27.0415 12.1796 26.1511 12.0534 26.059Z",
          fill: "url(#paint2_linear_1340_77668)"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M7.98301 24.2477C10.1602 24.7696 11.5801 24.831 12.5267 25.2915C12.5267 25.2915 12.8738 25.5985 13 25.752C13.1262 25.5985 13.4733 25.2915 13.4733 25.2915C14.4199 24.831 15.8398 24.7696 18.017 24.2477C20.7621 23.5722 23.7282 21.2082 23.7282 17.5241C23.7282 14.8838 22.182 13.9013 22.182 10.5549C22.182 8.283 23.0655 6.53302 23.0655 6.53302C23.0655 6.53302 21.0461 6.13391 20.0995 3.6471C20.0995 3.6471 18.7427 4.87515 16.8811 4.87515C14.5461 4.87515 13 3.27869 13 3.27869C13 3.27869 11.4539 4.87515 9.11894 4.87515C7.25729 4.87515 5.90049 3.6471 5.90049 3.6471C4.95389 6.13391 2.93447 6.53302 2.93447 6.53302C2.93447 6.53302 3.81797 8.283 3.81797 10.5549C3.81797 13.9013 2.27185 14.8838 2.27185 17.5241C2.27185 21.2389 5.23787 23.5722 7.98301 24.2477ZM22.75 17.5241C22.75 20.6556 20.1942 22.7126 17.7961 23.3266C16.0607 23.7565 13.9782 23.9714 13.3155 24.3398C13.1578 24.4319 13 24.6161 13 24.6161C13 24.6161 12.8107 24.4319 12.6845 24.3398C12.0534 24.0021 9.93932 23.7565 8.20389 23.3266C8.14078 23.2959 8.07767 23.2959 8.01457 23.2652L21.5825 13.3487C22.0558 14.9452 22.75 15.9583 22.75 17.5241ZM21.7718 7.08565C21.4879 7.88388 21.1723 9.14263 21.1723 10.5549C21.1723 11.1382 21.2039 11.6908 21.2985 12.1514L6.75243 22.774C4.92233 21.853 3.34467 20.103 3.25001 17.7083L19.9733 5.48918C20.5728 6.28741 21.2354 6.77863 21.7718 7.08565ZM4.82767 10.5549C4.82767 9.11193 4.51214 7.88388 4.22816 7.08565C4.85923 6.74793 5.67962 6.13391 6.31068 5.09006C7.00486 5.45848 7.98301 5.8576 9.11894 5.8576C10.8544 5.8576 12.2112 5.12076 13 4.56814C13.7888 5.12076 15.1456 5.8576 16.8811 5.8576C17.165 5.8576 17.4175 5.82689 17.6699 5.79619L3.43933 16.1732C3.84952 14.6075 4.82767 13.318 4.82767 10.5549Z",
          fill: "url(#paint3_linear_1340_77668)"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M9.11892 4.01551C11.4539 4.01551 13 2.08133 13 2.08133V0.853273L11.7694 2.01992C11.1383 2.63395 10.1286 3.12517 9.11892 3.12517C8.36163 3.12517 7.63591 2.78746 7.03639 2.29624L5.14319 0.761169L5.55338 2.20413C5.52183 2.20413 7.32037 4.01551 9.11892 4.01551Z",
          fill: "url(#paint4_linear_1340_77668)"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M24.8956 17.5241C24.8956 21.5459 21.9612 24.1862 18.2379 25.1073C16.2815 25.5985 14.9248 25.7213 13.9466 26.059C13.8204 26.1818 13 27.0414 13 27.0414V28.3002C13 28.3002 14.2621 26.98 14.4199 26.7958C15.7767 26.4274 16.6286 26.3967 18.4587 25.9362C22.1505 25.0152 25.4951 21.8836 25.4951 17.5241C25.4951 15.9583 25.148 15.0065 24.7694 14.0855L24.1068 14.1162C24.517 15.0987 24.8956 16.1732 24.8956 17.5241Z",
          fill: "url(#paint5_linear_1340_77668)"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M16.8811 4.01551C18.6796 4.01551 20.4781 2.23483 20.4781 2.23483L20.8883 0.761169L18.9951 2.29624C18.3641 2.78746 17.6699 3.12517 16.9126 3.12517C15.9029 3.12517 14.8932 2.63395 14.2621 2.01992L13.0315 0.853273V2.05062C13 2.08133 14.5461 4.01551 16.8811 4.01551Z",
          fill: "url(#paint6_linear_1340_77668)"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M5.52188 2.20413L5.14324 0.761169L4.2913 3.03307C3.91265 4.01551 3.31314 4.62953 2.4612 4.87514L0.536438 5.42777L1.73547 5.98039C1.73547 5.98039 4.73304 5.73478 5.52188 2.20413Z",
          fill: "url(#paint7_linear_1340_77668)"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M3.43932 16.1732L17.6699 5.76549C17.4175 5.7962 17.1335 5.8269 16.8811 5.8269C15.1456 5.8269 13.7888 5.09007 13 4.53744C12.2112 5.09007 10.8544 5.8269 9.11893 5.8269C7.98301 5.8269 7.00485 5.45848 6.31068 5.05936C5.67961 6.10321 4.85922 6.71723 4.22816 7.05495C4.51214 7.85318 4.82767 9.11194 4.82767 10.5242C4.82767 13.318 3.84951 14.6075 3.43932 16.1732ZM8.01456 23.2652C8.07767 23.2959 8.14078 23.2959 8.20388 23.3266C9.93932 23.7565 12.0218 23.9714 12.6845 24.3398C12.8422 24.4319 13 24.6161 13 24.6161C13 24.6161 13.1893 24.4319 13.3155 24.3398C13.9466 24.0021 16.0607 23.7565 17.7961 23.3266C20.1942 22.7433 22.75 20.6863 22.75 17.5241C22.75 15.9583 22.0558 14.9452 21.5825 13.3487L8.01456 23.2652ZM1.70388 10.5549C1.70388 13.5329 0.126214 14.2084 0.126214 17.5241C0.126214 22.2828 3.91262 25.4143 7.4466 26.3047C9.21359 26.7345 9.75 26.7652 11.3592 27.1336C11.4854 27.2564 13 28.8529 13 28.8529C13 28.8529 14.5146 27.2871 14.6408 27.1336C16.25 26.7345 16.7864 26.7345 18.5534 26.3047C22.0874 25.4143 25.8738 22.2828 25.8738 17.5241C25.8738 14.2084 24.2961 13.5329 24.2961 10.5549C24.2961 9.48035 24.517 8.40581 24.9903 7.39266L26 5.18217L23.6651 4.53744C22.9393 4.32253 22.4345 3.80061 22.0874 2.94097L21.0461 0.177857L18.7112 2.05064C18.1117 2.54186 17.4806 2.78747 16.8495 2.78747C16.0291 2.78747 15.0825 2.38835 14.483 1.80503L13 0.362065L11.517 1.80503C10.8859 2.41905 9.97087 2.78747 9.15049 2.78747C8.55097 2.78747 7.9199 2.54186 7.28884 2.05064L4.95388 0.147156L3.91262 2.91027C3.59709 3.76991 3.06068 4.32253 2.33495 4.50674L0 5.21287L1.00971 7.42336C1.45146 8.40581 1.70388 9.48035 1.70388 10.5549ZM2.46117 4.87516C3.31311 4.62955 3.91262 4.01552 4.29126 3.03308L5.1432 0.761182L7.03641 2.29625C7.66748 2.78747 8.36165 3.12518 9.11893 3.12518C10.1286 3.12518 11.1383 2.63396 11.7694 2.01994L13 0.853286L14.2306 2.01994C14.8617 2.63396 15.8714 3.12518 16.8811 3.12518C17.6383 3.12518 18.3641 2.78747 18.9636 2.29625L20.8568 0.761182L21.7087 3.03308C22.0874 4.01552 22.6869 4.62955 23.5388 4.87516L25.4636 5.42778L24.6432 7.23916C24.233 8.1602 23.9175 9.26544 23.9175 10.5549C23.9175 12.1514 24.3277 13.1031 24.7379 14.0855C25.1165 15.0066 25.4636 15.9583 25.4636 17.5241C25.4951 21.8837 22.1505 25.0152 18.4587 25.9362C16.6286 26.3968 15.7767 26.4275 14.4199 26.7959C14.2306 26.9801 13 28.3002 13 28.3002C13 28.3002 11.7379 26.9801 11.5801 26.7959C10.2233 26.4275 9.37136 26.3968 7.54126 25.9362C4.70146 25.2301 2.05097 23.2038 1.00971 20.2872C0.694175 19.4276 0.536408 18.5065 0.536408 17.5241C0.504854 14.2698 2.08252 13.6557 2.08252 10.5549C2.08252 9.29614 1.76699 8.1602 1.3568 7.23916L0.536408 5.42778L2.46117 4.87516ZM6.75243 22.774L21.2985 12.1514C21.2354 11.6601 21.1723 11.1382 21.1723 10.5549C21.1723 9.11194 21.4879 7.88388 21.7718 7.08565C21.2354 6.77864 20.5413 6.31812 19.9733 5.51988L3.25 17.739C3.34466 20.1337 4.95388 21.8837 6.75243 22.774ZM17.9223 8.06809V12.1207L20.1311 10.4935C20.1311 10.4935 20.068 11.0154 20.1311 11.8751L16.6602 14.4233V10.0944C16.6602 9.48035 16.0607 9.44965 16.0607 9.44965L17.9223 8.06809ZM13.0631 11.6294V13.6557L14.4515 12.6426V10.6163L15.6505 9.72596V15.1908L14.4515 16.1118V14.1162L13.0631 15.1294V17.125L11.801 18.046V13.6557C11.801 13.0417 11.2015 13.011 11.2015 13.011L13.0631 11.6294ZM7.9199 15.4057L9.46602 17.739V14.2698L10.6966 13.3794V18.8442L9.40291 19.796L8.01456 17.7083V20.8091L6.78398 21.6995V17.3092C6.78398 16.6952 6.18447 16.6645 6.18447 16.6645L7.9199 15.4057ZM2.90291 11.4452C2.65049 13.932 1.38835 14.9145 1.38835 17.5241C1.38835 20.717 3.66019 24.0942 7.76214 25.1073C9.71845 25.5985 11.0752 25.7213 12.0534 26.0591C12.1796 26.1819 13 27.0415 13 27.0415C13 27.0415 13.8204 26.1819 13.9466 26.0591C14.9248 25.7213 16.2816 25.5985 18.2379 25.1073C22.3714 24.0942 24.6117 20.717 24.6117 17.5241C24.6117 14.6075 23.0655 13.7171 23.0655 10.5549C23.0655 8.06809 24.2646 5.9804 24.2646 5.9804C24.2646 5.9804 21.267 5.73479 20.4782 2.20414C20.4782 2.20414 18.6796 3.98482 16.8811 3.98482C14.5461 3.98482 13 2.05064 13 2.05064C13 2.05064 11.4539 3.98482 9.11893 3.98482C7.32039 3.98482 5.52184 2.20414 5.52184 2.20414C4.73301 5.73479 1.73544 5.9804 1.73544 5.9804C1.73544 5.9804 2.93447 8.06809 2.93447 10.5549C2.96602 10.8926 2.93447 11.1689 2.90291 11.4452ZM2.96602 6.53303C2.96602 6.53303 4.98544 6.13391 5.93204 3.6471C5.93204 3.6471 7.28884 4.87516 9.15049 4.87516C11.4854 4.87516 13.0316 3.27869 13.0316 3.27869C13.0316 3.27869 14.5777 4.87516 16.9126 4.87516C18.7743 4.87516 20.1311 3.6471 20.1311 3.6471C21.0777 6.13391 23.0971 6.53303 23.0971 6.53303C23.0971 6.53303 22.2136 8.283 22.2136 10.5549C22.2136 13.9013 23.7597 14.8838 23.7597 17.5241C23.7597 21.2082 20.7937 23.5722 18.0485 24.2477C15.8714 24.7696 14.4515 24.831 13.5049 25.2915C13.5049 25.2915 13.1578 25.5985 13.0316 25.752C12.9053 25.5985 12.5583 25.2915 12.5583 25.2915C11.6117 24.831 10.1917 24.7696 8.01456 24.2477C5.26942 23.5722 2.3034 21.2082 2.3034 17.5241C2.3034 14.8838 3.84951 13.9013 3.84951 10.5549C3.81796 8.283 2.96602 6.53303 2.96602 6.53303Z",
          fill: "#111111"
        }
      )
    ] }),
    /* @__PURE__ */ o("defs", { children: [
      /* @__PURE__ */ o(
        "linearGradient",
        {
          gradientUnits: "userSpaceOnUse",
          id: "paint0_linear_1340_77668",
          x1: "0.278534",
          x2: "3.40633",
          y1: "12.8698",
          y2: "12.8698",
          children: [
            /* @__PURE__ */ C("stop", { offset: "0.11", stopColor: "white" }),
            /* @__PURE__ */ C("stop", { offset: "0.24", stopColor: "#DCDFE1" }),
            /* @__PURE__ */ C("stop", { offset: "0.44", stopColor: "#A8AFB3" }),
            /* @__PURE__ */ C("stop", { offset: "0.54", stopColor: "#949CA1" })
          ]
        }
      ),
      /* @__PURE__ */ o(
        "linearGradient",
        {
          gradientUnits: "userSpaceOnUse",
          id: "paint1_linear_1340_77668",
          x1: "24.2709",
          x2: "24.2709",
          y1: "14.1101",
          y2: "5.43701",
          children: [
            /* @__PURE__ */ C("stop", { stopColor: "white" }),
            /* @__PURE__ */ C("stop", { offset: "0.35", stopColor: "white" }),
            /* @__PURE__ */ C("stop", { offset: "0.56", stopColor: "#949CA1" }),
            /* @__PURE__ */ C("stop", { offset: "1", stopColor: "#949CA1" })
          ]
        }
      ),
      /* @__PURE__ */ o(
        "linearGradient",
        {
          gradientUnits: "userSpaceOnUse",
          id: "paint2_linear_1340_77668",
          x1: "1.00024",
          x2: "13.0063",
          y1: "24.0389",
          y2: "24.0389",
          children: [
            /* @__PURE__ */ C("stop", { offset: "0.15", stopColor: "white" }),
            /* @__PURE__ */ C("stop", { offset: "0.21", stopColor: "#FAFAFA" }),
            /* @__PURE__ */ C("stop", { offset: "0.29", stopColor: "#EBECED" }),
            /* @__PURE__ */ C("stop", { offset: "0.37", stopColor: "#D2D5D7" }),
            /* @__PURE__ */ C("stop", { offset: "0.45", stopColor: "#AFB5B9" }),
            /* @__PURE__ */ C("stop", { offset: "0.51", stopColor: "#949CA1" })
          ]
        }
      ),
      /* @__PURE__ */ o(
        "linearGradient",
        {
          gradientUnits: "userSpaceOnUse",
          id: "paint3_linear_1340_77668",
          x1: "20.1311",
          x2: "6.41216",
          y1: "23.4464",
          y2: "3.3156",
          children: [
            /* @__PURE__ */ C("stop", { stopColor: "#949CA1" }),
            /* @__PURE__ */ C("stop", { offset: "0.01", stopColor: "#99A1A6" }),
            /* @__PURE__ */ C("stop", { offset: "0.12", stopColor: "#C2C6C8" }),
            /* @__PURE__ */ C("stop", { offset: "0.2", stopColor: "#DBDDDE" }),
            /* @__PURE__ */ C("stop", { offset: "0.25", stopColor: "#E4E5E6" }),
            /* @__PURE__ */ C("stop", { offset: "0.75", stopColor: "#E4E5E6" }),
            /* @__PURE__ */ C("stop", { offset: "0.8", stopColor: "#DCDEDF" }),
            /* @__PURE__ */ C("stop", { offset: "0.87", stopColor: "#C7CACD" }),
            /* @__PURE__ */ C("stop", { offset: "0.97", stopColor: "#A3AAAE" }),
            /* @__PURE__ */ C("stop", { offset: "1", stopColor: "#949CA1" })
          ]
        }
      ),
      /* @__PURE__ */ o(
        "linearGradient",
        {
          gradientUnits: "userSpaceOnUse",
          id: "paint4_linear_1340_77668",
          x1: "5.13372",
          x2: "13.0063",
          y1: "2.38834",
          y2: "2.38834",
          children: [
            /* @__PURE__ */ C("stop", { offset: "0.25", stopColor: "white" }),
            /* @__PURE__ */ C("stop", { offset: "0.34", stopColor: "#FAFAFA" }),
            /* @__PURE__ */ C("stop", { offset: "0.45", stopColor: "#EBECED" }),
            /* @__PURE__ */ C("stop", { offset: "0.57", stopColor: "#D2D5D7" }),
            /* @__PURE__ */ C("stop", { offset: "0.7", stopColor: "#AFB5B9" }),
            /* @__PURE__ */ C("stop", { offset: "0.79", stopColor: "#949CA1" })
          ]
        }
      ),
      /* @__PURE__ */ o(
        "linearGradient",
        {
          gradientUnits: "userSpaceOnUse",
          id: "paint5_linear_1340_77668",
          x1: "13.0063",
          x2: "25.4951",
          y1: "21.1959",
          y2: "21.1959",
          children: [
            /* @__PURE__ */ C("stop", { offset: "0.2", stopColor: "white" }),
            /* @__PURE__ */ C("stop", { offset: "0.33", stopColor: "#FAFBFB" }),
            /* @__PURE__ */ C("stop", { offset: "0.47", stopColor: "#EDEEEF" }),
            /* @__PURE__ */ C("stop", { offset: "0.63", stopColor: "#D7DADC" }),
            /* @__PURE__ */ C("stop", { offset: "0.79", stopColor: "#B8BDC1" }),
            /* @__PURE__ */ C("stop", { offset: "0.93", stopColor: "#949CA1" })
          ]
        }
      ),
      /* @__PURE__ */ o(
        "linearGradient",
        {
          gradientUnits: "userSpaceOnUse",
          id: "paint6_linear_1340_77668",
          x1: "13.0063",
          x2: "20.8789",
          y1: "2.38834",
          y2: "2.38834",
          children: [
            /* @__PURE__ */ C("stop", { offset: "0.25", stopColor: "white" }),
            /* @__PURE__ */ C("stop", { offset: "0.34", stopColor: "#FAFAFA" }),
            /* @__PURE__ */ C("stop", { offset: "0.45", stopColor: "#EBECED" }),
            /* @__PURE__ */ C("stop", { offset: "0.57", stopColor: "#D2D5D7" }),
            /* @__PURE__ */ C("stop", { offset: "0.7", stopColor: "#AFB5B9" }),
            /* @__PURE__ */ C("stop", { offset: "0.79", stopColor: "#949CA1" })
          ]
        }
      ),
      /* @__PURE__ */ o(
        "linearGradient",
        {
          gradientUnits: "userSpaceOnUse",
          id: "paint7_linear_1340_77668",
          x1: "0.526972",
          x2: "5.53134",
          y1: "3.38306",
          y2: "3.38306",
          children: [
            /* @__PURE__ */ C("stop", { offset: "0.39", stopColor: "white" }),
            /* @__PURE__ */ C("stop", { offset: "0.47", stopColor: "#FAFAFA" }),
            /* @__PURE__ */ C("stop", { offset: "0.57", stopColor: "#EBECED" }),
            /* @__PURE__ */ C("stop", { offset: "0.67", stopColor: "#D2D5D7" }),
            /* @__PURE__ */ C("stop", { offset: "0.79", stopColor: "#AFB5B9" }),
            /* @__PURE__ */ C("stop", { offset: "0.87", stopColor: "#949CA1" })
          ]
        }
      ),
      /* @__PURE__ */ C("clipPath", { id: "clip0_1340_77668", children: /* @__PURE__ */ C("rect", { fill: "white", height: "29", width: "26" }) })
    ] })
  ] });
}
export {
  e as default
};
